module.exports = __webpack_public_path__ + "img/home-educacao.7b2b62ac.svg";